import { Component, type ErrorInfo, type ReactNode } from "react";
import { reportClientError } from "./monitoring";

export class ErrorBoundary extends Component<
  { children: ReactNode },
  { failed: boolean }
> {
  override state = { failed: false };
  static getDerivedStateFromError() {
    return { failed: true };
  }
  override componentDidCatch(error: Error, info: ErrorInfo) {
    reportClientError(
      new Error(`${error.message}\n${info.componentStack ?? ""}`),
    );
    console.error("Admin render failed", error, info.componentStack);
  }
  override render() {
    if (!this.state.failed) return this.props.children;
    return (
      <main className="login-page">
        <section className="login-card">
          <h1>Interfeysda xatolik yuz berdi</h1>
          <p>Sahifani qayta yuklab ko‘ring.</p>
          <button className="primary-button" onClick={() => location.reload()}>
            Qayta yuklash
          </button>
        </section>
      </main>
    );
  }
}
